// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tab--active[data-v-47b396ba]{color:#fff!important;background-color:#0b0e3c}.v-tab[data-v-47b396ba],.v-tab--active[data-v-47b396ba]{font-weight:700!important}.v-tab[data-v-47b396ba]{font-size:.745rem!important;padding:0 28px!important;letter-spacing:.04em!important}.v-tab[data-v-47b396ba]:before{background-color:transparent!important}", ""]);
// Exports
module.exports = exports;
